/* eslint-disable */
import Prism from 'prismjs'

const syntax = {
  comment: {
    pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ]+.+)*/m,
    lookbehind: !0
  },
  'multiline-script': {
    pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ]+.+|\s*?(?=\r?\n|\r)))+/m,
    lookbehind: !0,
    inside: {
      rest: Prism.languages.javascript
    }
  },
  filter: {
    pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ]+.+|\s*?(?=\r?\n|\r)))+/m,
    lookbehind: !0,
    inside: {
      'filter-name': {
        pattern: /^:[\w-]+/,
        alias: 'variable'
      }
    }
  },
  'multiline-plain-text': {
    pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ]+.+|\s*?(?=\r?\n|\r)))+/m,
    lookbehind: !0
  },
  markup: {
    pattern: /(^[\t ]*)<.+/m,
    lookbehind: !0,
    inside: {
      rest: Prism.languages.markup
    }
  },
  doctype: {
    pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
    lookbehind: !0
  },
  'flow-control': {
    pattern: /(^[\t ]*)(?:if|unless|else|case|when|default|each|while)\b(?: .+)?/m,
    lookbehind: !0,
    inside: {
      eachch: {
        pattern: /^each .+? in\b/,
        inside: {
          keyword: /\b(?:each|in)\b/,
          punctuation: /,/
        }
      },
      branch: {
        pattern: /^(?:if|unless|else|case|when|default|while)\b/,
        alias: 'keyword'
      },
      rest: Prism.languages.javascript
    }
  },
  keyword: {
    pattern: /(^[\t ]*)(?:block|extends|include|append|prepend)\b.+/m,
    lookbehind: !0
  },
  mixin: [
    {
      pattern: /(^[\t ]*)mixin .+/m,
      lookbehind: !0,
      inside: {
        keyword: /^mixin/,
        function: /\w+(?=\s*\(|\s*$)/,
        punctuation: /[(),.]/
      }
    },
    {
      pattern: /(^[\t ]*)\+.+/m,
      lookbehind: !0,
      inside: {
        name: {
          pattern: /^\+\w+/,
          alias: 'function'
        },
        rest: Prism.languages.javascript
      }
    }
  ],
  script: {
    pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]+).+/m,
    lookbehind: !0,
    inside: {
      rest: Prism.languages.javascript
    }
  },
  'plain-text': {
    pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]+).+/m,
    lookbehind: !0
  },
  tag: {
    pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
    lookbehind: !0,
    inside: {
      attributes: [
        {
          pattern: /&[^(]+\([^)]+\)/,
          inside: {
            rest: Prism.languages.javascript
          }
        },
        {
          pattern: /\([^)]+\)/,
          inside: {
            'attr-value': {
              pattern: /(=\s*)(?:\{[^}]*\}|[^,)\r\n]+)/,
              lookbehind: !0,
              inside: {
                rest: Prism.languages.javascript
              }
            },
            'attr-name': /[\w-]+(?=\s*!?=|\s*[,)])/,
            punctuation: /[!=(),]+/
          }
        }
      ],
      punctuation: /:/
    }
  },
  code: [
    {
      pattern: /(^[\t ]*(?:-|!?=)).+/m,
      lookbehind: !0,
      inside: {
        rest: Prism.languages.javascript
      }
    }
  ],
  punctuation: /[.\-!=|]+/
}

export default syntax



// WEBPACK FOOTER //
// ./src/components/Settings/Motd/partials/CodeEditor/langs/pug.js